function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default function TopVendors({ revenueStats }) {
  const topVendors = revenueStats?.top_businesses || [];

  return (
    <div className="bg-white dark:bg-[#121212] rounded-lg p-4 sm:p-6 border border-gray-200 dark:border-gray-700 min-w-0">
      <h2 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white mb-4">
        Top 5 Vendors
      </h2>

      {topVendors.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-500 dark:text-gray-400">
            No vendor data available
          </p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200 dark:border-gray-700">
                <th className="text-left py-3 px-2 text-sm font-semibold text-gray-600 dark:text-gray-400">
                  Name
                </th>
                <th className="text-right py-3 px-2 text-sm font-semibold text-gray-600 dark:text-gray-400">
                  Revenue
                </th>
                {/* <th className="text-right py-3 px-2 text-sm font-semibold text-gray-600 dark:text-gray-400">
                  Min. Payout
                </th>
                <th className="text-right py-3 px-2 text-sm font-semibold text-gray-600 dark:text-gray-400">
                  Max. Payout
                </th> */}
              </tr>
            </thead>
            <tbody>
              {topVendors.map((vendor, index) => (
                <tr
                  key={vendor.model_id || index}
                  className="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-900"
                >
                  <td className="py-4 px-2">
                    <p className="font-medium text-gray-900 dark:text-white capitalize break-words">
                      {vendor?.model?.business_name}
                    </p>
                  </td>
                  <td className="py-4 px-2 text-right whitespace-nowrap">
                    <p className="font-semibold">
                      {vendor.currency} {numberWithCommas(vendor?.total_revenue)}
                    </p>
                  </td>
                  {/* <td className="py-4 px-2 text-right">
                    <p className="text-gray-600 dark:text-gray-400">
                      {vendor.min_payout != null ? numberWithCommas(vendor.min_payout) : "-"}
                    </p>
                  </td>
                  <td className="py-4 px-2 text-right">
                    <p className="text-gray-600 dark:text-gray-400">
                      {vendor.max_payout != null ? numberWithCommas(vendor.max_payout) : "-"}
                    </p>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
